<template>
    <div>
        <wrapper-edit
                :wrapper-width="wrapperWidth"
                @back="paasPageBack">
            <Form ref="paasForm" slot="form"
                  :model="paasFormData"
                  :rules="paasFormRules"
                  :label-width="defaultLabelWidth">
                <Row>
                    <FormItem label="卡种类：" prop="cardCategory" class="ivu-col-span-12" >
                        <Enum :enumJsonKey="'crmdict-cardCategory'"  v-model="paasFormData.cardCategory" ></Enum>
                    </FormItem>
                    <FormItem label="卡类型：" prop="cardType" class="ivu-col-span-12" >
                        <Enum :enumJsonKey="'crmdict-cardType'"  v-model="paasFormData.cardType" ></Enum>
                    </FormItem>
                </Row>
                <Row>
                    <FormItem label="卡的名称：" prop="cardName" class="ivu-col-span-12" >
                        <Input v-model="paasFormData.cardName"
                               clearable ></Input>
                    </FormItem>
                    <FormItem label="排序：" prop="displayOrder" class="ivu-col-span-12" >
                        <Input v-model="paasFormData.displayOrder"
                               clearable ></Input>
                    </FormItem>

                </Row>
                <Row>
                    <FormItem label="是否定制：" prop="isCustomMade" class="ivu-col-span-12" >
                        <Enum :enumJsonKey="'crmdict-isShelf'"  v-model="paasFormData.isCustomMade"  type="radio" ></Enum>
                    </FormItem>
                    <FormItem label="定制单位：" prop="unitName" class="ivu-col-span-12" >
                        <Input v-model="paasFormData.unitName"
                               clearable ></Input>
                    </FormItem>
                </Row>
                <Row>
                    <FormItem label="面值：" prop="faceValue" class="ivu-col-span-12" >
                        <Input v-model="paasFormData.faceValue"
                               clearable search enter-button="元"></Input>
                    </FormItem>
                    <FormItem label="售价：" prop="salePrice" class="ivu-col-span-12" >
                        <Input v-model="paasFormData.salePrice"
                               clearable search enter-button="元" ></Input>
                    </FormItem>
                </Row>
                <Row>
                    <FormItem label="详情介绍：" prop="introDesc" class="ivu-col-span-24" >
                        <Input v-model="paasFormData.introDesc"
                               type="textarea"  clearable ></Input>
                    </FormItem>
                </Row>
                <Row>
                    <FormItem label="是否上架：" prop="isShelf" class="ivu-col-span-12" >
                        <Enum :enumJsonKey="'crmdict-isShelf'"  v-model="paasFormData.isShelf"  type="radio" ></Enum>
                    </FormItem>
                    <FormItem label="有效状态：" prop="isDelete" class="ivu-col-span-12" >
                        <Enum :enumJsonKey="'crmdict-isDelete'"  v-model="paasFormData.isDelete"  type="radio" ></Enum>
                    </FormItem>
                </Row>
                <Row>
                    <FormItem label="卡正面图:" class="ivu-col-span-24">
                        <FileUpload :action="uploadPath" :param="cardPositiveParam"
                                    :fileBusinessId="paasFormData.paasRepeatSubmitFlag"
                                    v-model="positiveFiles" ref="positive">
                            <Button type="primary">卡正面图上传</Button>
                        </FileUpload>
                    </FormItem>
                </Row>
               <!--<Row>
                    <FormItem label="卡背面图:" class="ivu-col-span-24">
                        <FileUpload :action="uploadPath" :param="cardBackParam"
                                    :fileBusinessId="paasFormData.paasRepeatSubmitFlag"
                                    v-model="backFiles"
                                    ref="back">
                            <Button type="primary">卡正面图上传</Button>
                        </FileUpload>
                    </FormItem>
                </Row>-->
                <div class="edit-oper-toolbar">
                    <Button type="primary" @click="paasFormSubmit('paasForm','','add')">保存并继续添加</Button>
                    <Button @click="paasFormSubmit('paasForm','','cardTypesList')" style="margin-left: 8px">保存并返回</Button>
                    <Button @click="paasPageBack" style="margin-left: 8px">返回</Button>
                </div>
            </Form>
        </wrapper-edit>
    </div>
</template>
<script>
    import wrapperEdit from "@/components/paas/wrapper-edit";
    import metaEdit from "@/assets/js/meta-edit.js";
    import Enum from '@/components/paas/enum-form' //枚举渲染
    import FileUpload from '@components/paas/file-upload.vue';
    export default {
        name: "edit",
        mixins:[metaEdit],
        components:{wrapperEdit,Enum,FileUpload},
        data(){
            return {
                serviceUrl:"/eb/card/types",  //每个页面访问后台服务器的路径
                currentIdFiledName: 'id',
                paasFormData:{
                    id:'',
                    cardCategory:'',
                    cardType:'',
                    cardName:'',
                    isCustomMade:'',
                    unitName:'',
                    faceValue:'',
                    salePrice:'',
                    positiveImage:'',
                    backImage:'',
                    isShelf:'',
                    introDesc:'',
                    displayOrder:'',
                    timeCreate:'',
                    isDelete:'',
                },
                paasFormRules:{
                },
                redirectName:"cardTypesList",
                nextAddName:"cardTypesEdit",
                positiveFiles:[],
                backFiles:[],
                uploadPath: this.$store.state.sysApi+"/sys/file/uploadFileSlice",
                cardPositiveParam: {businessType: 'cardTypes', businessProperty: 'positive', businessId: '',tempId:'',basedictStorage:'ossServer'},
                cardBackParam: {businessType: 'cardTypes', businessProperty: 'back', businessId: '',tempId:'',basedictStorage:'ossServer'},
            }
        },
        methods:{
            createdCallback(data) {
                this.cardPositiveParam.businessId = this.paasFormData.id;
                this.cardPositiveParam.tempId = this.paasFormData.paasRepeatSubmitFlag;
                this.positiveFiles = data.entity.positiveImages;
                this.backFiles = data.entity.backImages;
            },
        },
    }
</script>
